const getters = {
  getEmpresas: state => state.empresas,
  getUltimaEmpresa: state => state.ultimaEmpresa
}

export default getters
